// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"17713501","395":"eebf0948","899":"ade65084"}[chunkId] + ".chunk.js";
};